import { createRouter, createWebHistory } from 'vue-router';
import db from "../helpers/db";

import auth from './auth';
import patient from './patient';
import toSchedule from './toSchedule';
import professionalProfile from './professionalProfile';
import SurveyAnswer from "@/views/survey/SurveyAnswer.vue";
import SurveySuccess from "@/views/survey/SurveySuccess.vue";
import ScheduleCardCheckout from "@/views/checkout/ScheduleCardCheckout.vue";

const routes = [
    ...auth,
    ...patient,
    ...toSchedule,
    ...professionalProfile,
    {
        path: '/checkout/:id',
        name: 'ScheduleCardCheckout',
        component: ScheduleCardCheckout,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/survey/:token',
        name: 'SurveyAnswer',
        component: SurveyAnswer,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: '/survey/success',
        name: 'SurveySuccess',
        component: SurveySuccess,
        meta: {
            auth: false,
            scheduling: true,
            layout: 'guest-layout'
        }
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404",
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.auth)) {
        if (db.token == null || db.token === 'null') {
            next({path: '/login', params: {nextUrl: to.fullPath}});
        } else {
            next();
        }
    } else {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);

        next();
    }
});

export default router
